import { render, staticRenderFns } from "./BookingCalendar.vue?vue&type=template&id=2a67e073&scoped=true&"
import script from "./BookingCalendar.vue?vue&type=script&lang=js&"
export * from "./BookingCalendar.vue?vue&type=script&lang=js&"
import style0 from "./BookingCalendar.vue?vue&type=style&index=0&id=2a67e073&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a67e073",
  null
  
)

export default component.exports